import React from "react";
import moment from "moment";

const AzureUserDetails = ({ user }) => {
  const details = [
    { label: "Name", value: user?.displayName },
    { label: "SurName", value: user?.surname },
    { label: "Azure ID", value: user?.azureId },
    { label: "Department", value: user?.department },
    { label: "Principal Name", value: user?.user?.rincipalName },
    { label: "Account Enabled", value: user?.accountEnabled?.toString() },
    { label: "Preferred Language", value: user?.preferredLanguage },
    { label: "Job Title", value: user?.jobTitle },
    { label: "Mail", value: user?.mail },
    { label: "Office Location", value: user?.officeLocation },
    {
      label: "Synced At",
      value: user?.synced_at
        ? moment(user.synced_at).format("DD/MM/YYYY HH:mm:ss")
        : "N/A",
    },
  ];

  return (
    <ul className="space-y-3">
      {details.map(({ label, value }, index) => (
        <li key={index} className="text-base text-gray-700">
          <strong>{label}:</strong>{" "}
          <span className="text-gray-900">{value || "N/A"}</span>
        </li>
      ))}
    </ul>
  );
};

export default AzureUserDetails;
